type PathType =
  | "login"
  | "dashboard"
  | "deliveryRequestRegisterStart"
  | "deliveryRequestRegisterInput"
  | "deliveryRequestList"
  | "deliveryMoveRegister"
  | "deliveryMoveList"
  | "fixturesRegister"
  | "memberRegister"
  | "memberList"
  | "tmpMemberList"
  | "tmpMemberQrCode"
  | "shopRegister"
  | "shopList"
  | "serverSetting"
  | "chainRegister"
  | "operatorRegister"
  | "operatorList"
  | "areaList"
  | "deliverySetting"
  | "deliveryCapSetting"
  | "scheduledDeliveryList"
  | "scheduledDeliveryRegister"
  | "salesSummaryList"
  | "regularDeliveryList"
  | "regularDeliveryRegister"
  | "passwordChange";

/**
 * router の path 定義
 */
export const routerPath: {
  [key in PathType]: string;
} = {
  /* ログイン */
  login: "/",

  /* ダッシュボード */
  dashboard: "/dashboard",

  /* 配送依頼登録-開始 */
  deliveryRequestRegisterStart: "/delivery/request",

  /* 配送依頼登録-入力 */
  deliveryRequestRegisterInput: "/delivery/request_reg",

  /* 配送依頼一覧 */
  deliveryRequestList: "/delivery/request_lst",

  /* 在庫移動登録-入力 */
  deliveryMoveRegister: "/delivery/move_reg",

  /* 在庫移動一覧 */
  deliveryMoveList: "/delivery/move_lst",

  /* 資材発注登録 */
  fixturesRegister: "/delivery/fixtures_reg",

  /* 会員登録 */
  memberRegister: "/delivery/member_reg",

  /* 会員一覧 */
  memberList: "/delivery/member_lst",

  /* 仮会員一覧 */
  tmpMemberList: "/delivery/tmp_member_lst",

  /* 仮会員登録用QRコード */
  tmpMemberQrCode: "/delivery/tmp_member_qr",

  /* 店舗登録 */
  shopRegister: "/admin/shop/shop_reg",

  /* 店舗一覧 */
  shopList: "/delivery/shop_lst",

  /* サーバー設定 */
  serverSetting: "/admin/server/server_setting",

  /* チェーン登録 */
  chainRegister: "/admin/chain/chain_reg",

  /* オペレータ登録 */
  operatorRegister: "/admin/operator/operator_reg",

  /* オペレータ一覧 */
  operatorList: "/admin/operator/operator_lst",

  /* エリア一覧 */
  areaList: "/admin/area/area_lst",

  /* 配達設定 */
  deliverySetting: "/admin/delivery/delivery_setting",

  /* キャップ設定 */
  deliveryCapSetting: "/admin/delivery/delivery_cap_setting",

  /* 店舗間定期配達・一覧 */
  scheduledDeliveryList: "/admin/delivery/scheduled_delivery_list",

  /* 店舗間定期配達 */
  scheduledDeliveryRegister: "/admin/delivery/scheduled_delivery_reg",

  /* 日別売り上げ */
  salesSummaryList: "/admin/delivery/sales_summary_list",

  /* 定期配送・一覧 */
  regularDeliveryList: "/delivery/regular_delivery_list",

  /* 定期配送 */
  regularDeliveryRegister: "/delivery/regular_delivery_reg",

  /* パスワード変更 */
  passwordChange: "/password_change",
};
